import * as React from 'react';
import cn from '~modules/cn';

import './input-group.scss';

export type InputGroupType = 'negative' | 'positive';

type InputGroupProps = {
    type?: InputGroupType;
    isValid?: boolean;
    withButton?: boolean;
    children: React.ReactNode;
};

type Props = React.HTMLAttributes<HTMLElement> & InputGroupProps;

const InputGroup = ({ className, children, type, withButton = false, ...props }: Props): JSX.Element => (
    <div {...props} className={cn('input-group', { 'input-group--with-button': withButton, [`input-group--${type}`]: type }, className)}>
        {children}
    </div>
);

InputGroup.displayName = 'InputGroup';

export default InputGroup;
